import React from "react";
import { StyledSVG } from "../styled";
import { sizes } from "../options";

const SideBarToggle = ({ variant, size }) => (
  <StyledSVG
    variant={variant}
    size={size}
    viewBox={`0 0 ${sizes[size].width.split("p")[0]} ${sizes[size].height.split("p")[0]}`}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path fillRule="evenodd" clipRule="evenodd" d="M1.99988 1.25C1.58566 1.25 1.24988 1.58579 1.24988 2V14C1.24988 14.4142 1.58566 14.75 1.99988 14.75H5.99988C5.99992 14.75 5.99996 14.75 6 14.75H14C14.4142 14.75 14.75 14.4142 14.75 14V2C14.75 1.58579 14.4142 1.25 14 1.25H6C5.99996 1.25 5.99992 1.25 5.99988 1.25H1.99988ZM2.74988 13.25V2.75H5.24988V13.25H2.74988ZM6.75 13.25V2.75H13.25V13.25H6.75Z" />
  </StyledSVG>
);

export default SideBarToggle;
